import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import { Label } from "reactstrap";
import { baseurl } from "../../../baseurl";

var username = localStorage.getItem("username");
var token = localStorage.getItem("token");
var companyId = localStorage.getItem("companyId");

const YourComponent = ({
  label,
  value,
  callBack,
  sendDataBack,
  isRequired,
  isMulti,
  isDisabled = false,
  branch,
  isFromMeatProcessing = false,
}) => {
  const [lovValue, setLovValue] = useState(value || "");
  const [lovOptions, setLovOptions] = useState("");
  // useEffect(() => {
  //   // alert(lovValue?.id);
  //   getDynamicBranchLov();
  // }, [lovValue]);

  useEffect(() => {
    if (value) {
      setLovValue(value);
    }
  }, [value]);

  useEffect(() => {
    getDynamicBranchLov();
  }, [branch]);

  const getDynamicBranchLov = () => {
    axios
      .post(
        // `${baseurl}/lovs/getProductionCenterDetLov`,
        `${baseurl}/lovs/getDynamicBranchLov`,

        { branch: branch, companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        // let mydata = [];
        let responseData = response.data.data;
        console.log("responseData[0]=", responseData[0]);
        // setLovValue(responseData[0]);
        // callBack(responseData[0]);
        setLovOptions(responseData);

        if(isFromMeatProcessing && responseData.length > 0){
          setLovValue(responseData[0]);
          callBack(responseData[0]);
        }

      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // Function to handle state selection
  const handleChangeLovsSelect = (customer_id) => {
    console.log("branchID=", customer_id);

    setLovValue(customer_id);
    callBack(customer_id);
  };

  return (
    <div className=" row">
      <div className="col-md-12">
        {label ? (
          <Label translate="yes" style={{ fontWeight: "bold" }}>
            {label}
            {""}
            <h8 style={{ color: "tomato" }}>*</h8>
          </Label>
        ) : (
          ""
        )}

        <Select
          value={lovValue}
          onChange={handleChangeLovsSelect}
          placeholder="All Selected"
          options={lovOptions}
          // autoFocus
          isClearable
          name="selectedOptionPhase"
          isDisabled={isDisabled}
          isMulti={isMulti}
          required={isRequired}
          title="Select Branch"
        />
      </div>
    </div>
  );
};

export default YourComponent;
